import { RestSchemas } from '@/contexts/QueryProvider'

export type SkillSummary = RestSchemas['Messages.Skill.SkillSummary']

export type SkillScopeFilter = 'all' | 'platform' | 'owned' | 'shared' | 'public'

export function getScopeFilterValue(skill: SkillSummary): SkillScopeFilter[] {
  const scopes: SkillScopeFilter[] = []
  if (skill.isPlatform) scopes.push('platform')
  if (skill.isPublic) scopes.push('public')
  return scopes
}

export function getVisibilityLabel(skill: SkillSummary) {
  if (skill.isPlatform) return 'Platform'
  return skill.isPublic ? 'Public' : 'Private'
}
